import React, { useState } from "react";
import { Plus, X } from "lucide-react";

export const STANDARD_REQUIREMENTS = [
  ["pos", "POS"],
  ["pimus", "PIMUS"],
  ["piano_demolizioni", "PIANO DELLE DEMOLIZIONI"],
  ["durc", "DURC"],
  ["cciaa", "VISURA"],
  ["organico_medio", "ORGANICO MEDIO"],
  ["documento_identita_amministratore", "DOCUMENTO DI IDENTITÀ AMMINISTRATORE"],
  ["verbale_accertamento_requisiti", "VERBALE ACCERTAMENTO REQUISITI"],
];

export const defaultRequirements = (standard = STANDARD_REQUIREMENTS) =>
  standard.map(([doc_type, label]) => ({ doc_type, label, mandatory: true }));

const slug = text => "custom_" + text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 40);

const Switch = ({ on, onClick, testId, label }) => (
  <button type="button" role="switch" aria-checked={on} aria-label={label} data-testid={testId} onClick={onClick}
    style={{ width: 40, height: 22, minHeight: 22, borderRadius: 11, padding: 0, flexShrink: 0, background: on ? "var(--wine)" : "#D2D2D7", position: "relative", transition: "background .15s" }}>
    <span style={{ position: "absolute", top: 3, left: on ? 21 : 3, width: 16, height: 16, borderRadius: "50%", background: "#fff", transition: "left .15s" }} />
  </button>
);

export function RequirementsEditor({ value = [], onChange, standard = STANDARD_REQUIREMENTS, prefix = "req" }) {
  const [custom, setCustom] = useState("");
  const enabled = key => value.some(r => r.doc_type === key);
  const entry = key => value.find(r => r.doc_type === key);
  function toggle(doc_type, label) {
    onChange(enabled(doc_type) ? value.filter(r => r.doc_type !== doc_type) : [...value, { doc_type, label, mandatory: true }]);
  }
  function setMandatory(doc_type, mandatory) {
    onChange(value.map(r => r.doc_type === doc_type ? { ...r, mandatory } : r));
  }
  function addCustom() {
    const label = custom.trim().toUpperCase();
    if (label.length < 3) return;
    const doc_type = slug(label);
    if (!doc_type || enabled(doc_type)) { setCustom(""); return; }
    onChange([...value, { doc_type, label, mandatory: true, custom: true }]);
    setCustom("");
  }
  const extra = value.filter(r => !standard.some(([key]) => key === r.doc_type));
  const row = (doc_type, label, isCustom) => {
    const on = enabled(doc_type);
    return <div key={doc_type} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderTop: "1px solid var(--line)" }}>
      <Switch on={on} label={label} testId={`${prefix}-switch-${doc_type}`} onClick={() => toggle(doc_type, label)} />
      <span style={{ flex: 1, fontSize: 12.5, color: on ? "var(--ink)" : "var(--muted)", fontWeight: on ? 500 : 400, overflowWrap: "anywhere" }}>{label}</span>
      {on && <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 10.5, color: "var(--muted)", margin: 0, whiteSpace: "nowrap" }}>
        <input type="checkbox" data-testid={`${prefix}-mandatory-${doc_type}`} checked={entry(doc_type)?.mandatory !== false} onChange={e => setMandatory(doc_type, e.target.checked)} style={{ width: 15, height: 15, accentColor: "var(--wine)", margin: 0 }} />
        Blocca ingresso
      </label>}
      {isCustom && <button type="button" className="icon-btn" title="Rimuovi requisito" data-testid={`${prefix}-remove-${doc_type}`} onClick={() => onChange(value.filter(r => r.doc_type !== doc_type))}><X size={13} /></button>}
    </div>;
  };
  return <div data-testid={`${prefix}-editor`} style={{ margin: "6px 0 4px" }}>
    <p className="eyebrow" style={{ margin: "0 0 4px" }}>REQUISITI MINIMI TECNICO-PROFESSIONALI</p>
    <p className="muted" style={{ fontSize: 11, margin: "0 0 6px" }}>Attiva i requisiti da richiedere all'impresa. "Blocca ingresso" rende il documento obbligatorio per l'autorizzazione.</p>
    {standard.map(([doc_type, label]) => row(doc_type, label, false))}
    {extra.map(r => row(r.doc_type, r.label, true))}
    <div style={{ display: "flex", gap: 8, alignItems: "center", paddingTop: 12, borderTop: "1px solid var(--line)" }}>
      <input data-testid={`${prefix}-custom-input`} value={custom} placeholder="Nuovo requisito personalizzato" onChange={e => setCustom(e.target.value)}
        onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addCustom(); } }} style={{ flex: 1 }} />
      <button type="button" className="ghost" data-testid={`${prefix}-custom-add`} onClick={addCustom}><Plus size={14} />Aggiungi</button>
    </div>
  </div>;
}
